const Tooltip = (props) => {
  return (
    <span className="tooltip show fav-tooltip">
      <span className="arrow"></span>
      <span className="tooltip-inner">{props.tipText}</span>
    </span>
  );
};
export default Tooltip;
